import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiForumViewComponent } from './fi-forum-view.component';
import { FiForumViewContainerComponent } from '@fi-shared/fi-forum/fi-forum-view/fi-forum-view-container.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { MatCardModule } from '@angular/material/card';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { MatButtonModule } from '@angular/material/button';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiForumPostEditModule } from '@fi-shared/fi-forum/fi-forum-post-edit/fi-forum-post-edit.module';
import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatIconModule } from '@angular/material/icon';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiItemsListModule,
        MatCardModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        FiWhenScrolledModule,
        MatSortModule,
        MatTableModule,
        MatButtonModule,
        FiFormatDateModule,
        FiForumPostEditModule,
        FiStateSrefModule,
        FiButtonBackNewModule,
        FiPageHeaderButtonGroupModule,
        MatIconModule,
        FiProfileIconModule,
        MatMenuModule,
        FiLineClampModule,
    ],
    declarations: [FiForumViewComponent, FiForumViewContainerComponent],
    exports: [FiForumViewComponent],
})
export class FiForumViewModule {}
